export default "__VITE_ASSET___eM3tKax__"